import React from 'react'
import { Box, Text, createStandaloneToast } from '@chakra-ui/react'
const toast = createStandaloneToast()


export function Processing(type, title, description) {
  toast({
    position: 'bottom-right',
    title: title,
    description: description,
    status: type,
    duration: 6000,
    isClosable: true
  })
}

export function NewProject(name) {
  Processing('warning', <Box>New project added: <Text fontSize="lg" isTruncated>{name}</Text></Box>, 'Check back in 5 min’s. Processing...')
}

export function NewKeywords() {
  Processing('warning', 'New keywords added', <Box><Box>Check back in 5 min’s</Box><Box>Processing data...</Box></Box>)
}
export function NewCompetitors() {
  Processing('warning', 'New competitor(s) added', <Box><Box>Check back in 5 min’s</Box><Box>Processing data...</Box></Box>)
}

export function DeletedProject() {
  Processing('error', 'Project deleted')
}

export function AuditRestart() {
  Processing('success', 'New Audit started', <Box><Box>Check back in 5 min’s</Box><Box>Processing data...</Box></Box>)
}